import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import VueClipboard from 'vue-clipboard2'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import router from "@/router/index.js";
import App from './App.vue'
import axios from 'axios';

axios.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.response && error.response.status === 401) {
        window.dispatchEvent(new CustomEvent('show-login-prompt'));
    }
    return Promise.reject(error);
});

const app = createApp(App)

app.use(ElementPlus)
app.use(VueClipboard)
app.use(router)

app.mount('#app')
